@if (!historyLoading() && historyData().length === 0) {
<div class="text-muted" translate>No previous exports found</div>
} @if (historyData().length > 0) {
<av-card [backdrop]="false">
  @for (composition of historyData(); track trackByFn($index, composition)) {
  <av-card-row>
    <app-composition-row
      [composition]="composition"
      (navigate)="go($event)"
      (cancelRequested)="cancelExport($event)"
      (removed)="removed($event)"
    >
    </app-composition-row>
  </av-card-row>
  } @if (historyPager()?.totalPages > 1) {
  <av-card-row class="pager text-center">
    <av-pager
      [totalPages]="historyPager()?.totalPages"
      [pageIndex]="historyPager()?.number"
      (pageChange)="nextPageLoading($event)"
    ></av-pager>
  </av-card-row>
  }
</av-card>
}
